import { encryptedMarketplaceId } from '@/constants';
import { getAsinBatch } from '@/models/api/detailPageApi';
export const allProps = {
  isShowPopup: {
    type: Boolean,
    required: true,
    default: () => false
  },
  selectedAsin: {
    type: String,
    required: true,
    default: () => ''
  },
  merchantId: {
    type: String,
    required: false
  },
  isFromAsinList: {
    type: Boolean,
    required: false,
    default: () => false
  },
  isAddToCart: {
    type: Boolean,
    required: false,
    default: () => true
  },
  isProductReplace: {
    type: Boolean,
    default: () => false
  },
  quantity: {
    type: Number,
    default: () => 1
  },
  promotionInfoList: {
    type: Array,
    default: () => []
  },
  marginBottom: {
    required: false,
    type: Number
  }
};

export const batchList = async asinList => {
  const { data } = await getAsinBatch({
    ids: asinList,
    marketplace: encryptedMarketplaceId,
    withCache: false,
    allowOtherOffer: false,
    returnableFlagSkipped: false
  });

  return data;
};

// Split request parameters,Default to 20 as a group
export function handleChunkArr(arr, size = 20) {
  if (!arr.length || !size || size < 1) return [];
  let [start, end] = [null, null];
  const result = [];
  for (let index = 0; index < Math.ceil(arr.length / size); index++) {
    start = index * size;
    end = start + size;
    result.push(arr.slice(start, end));
  }
  return result;
}

// Splicing specifications
const calcCombination = (prev, current) => {
  let index = 0;
  const result = [];
  for (let prevIndex = 0; prevIndex < prev.length; prevIndex++) {
    for (let currentIndex = 0; currentIndex < current.length; currentIndex++) {
      const prevList = prev[prevIndex];
      if (Array.isArray(prevList)) {
        result[(index += 1)] = [...prevList, currentIndex];
      } else {
        result[(index += 1)] = [prevIndex, currentIndex];
      }
    }
  }
  return result;
};

// Calculate the combination of all specifications
export const combineDiffProductStyles = arr => {
  if (arr.length === 1) {
    const arrList = arr[0];
    const res = [];
    for (let i = 0; i < arrList.length; i++) {
      res.push({ indexKey: i, values: [i], spec: arr[i] });
    }
    return res;
  }
  const list = arr.reduce((prev, current) => {
    return calcCombination(prev, current);
  });
  return list.map((item, index) => {
    return {
      indexKey: index,
      values: item
    };
  });
};
export const TWISTER_DIMENSION = {
  size_name: 'SIZE_NAME',
  color_name: 'COLOR_NAME',
  flavor_name: 'FLAVOR_NAME',
  style_name: 'STYLE_NAME',
  special_size_type: 'SPECIAL_SIZE_TYPE',
  customer_package_type: 'CUSTOMER_PACKAGE_TYPE',
  band_color: 'BAND_COLOR',
  Edition: 'EDITION',
  Item_package_quantity: 'ITEM_PACKAGE_QUANTITY',
  configuration: 'CONFIGURATION'
};
